import { render } from "./verify.vue?vue&type=template&id=2f16aa29"
import script from "./verify.vue?vue&type=script&lang=js"
export * from "./verify.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./verify.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__